import React from 'react';

import { I18n } from 'aws-amplify';
import {
  AuthPiece,
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  InputRow,
  ButtonRow,
  Link,
  Radio,
  Checkbox,
} from 'aws-amplify-react';

import LogoArea from './logoarea.js';
import Stepper from './stepper.js';

const buttonOkTheme = {
  button: {
    backgroundColor: '#1a66ff',
    backgroundImage: 'none',
    border: '1px solid transparent',
    borderColor: '#1a66ff',
    borderRadius: '4px',
    color:'#ffffff',
    cursor: 'pointer',
    display: 'inline-block',
    height:'64px',
    fontSize: '1.5em',
    fontWeight: 400,
    lineHeight: '1.42857143',
    marginBottom: '72px',
    padding: '6px 12px',
    textAlign: 'center',
    touchAction: 'manipulation',
    userSelect: 'none',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  },
};
const buttonNgTheme = {
  button: {
    backgroundColor: '#c2c2c2',
    backgroundImage: 'none',
    border: '1px solid transparent',
    borderColor: '#c2c2c2',
    borderRadius: '4px',
    color:'#959595',
    cursor: 'default',
    display: 'inline-block',
    height:'64px',
    fontSize: '1.5em',
    fontWeight: 400,
    lineHeight: '1.42857143',
    marginBottom: '72px',
    padding: '0 12px',
    textAlign: 'center',
    touchAction: 'manipulation',
    userSelect: 'none',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  },
};
// 個人情報入力画面
export default class SecondSignUp extends AuthPiece {
  constructor (props) {
    super(props);
    this.state = {
      buttonTheme: buttonNgTheme,
    };
    this._validAuthStates = ['secondSignUp'];
    this.userProfile = {};
    this.errorState = {
      nameErrorStyle: false,
      orgtypeErrorStyle: true,
      orgnameErrorStyle: false,
      agreementErrorStyle: false,
    };
  }
  // デフォルトで組織に所属しているようにする
  setDefault = () => {
    this.inputs = {
      family_name: '',
      given_name: '',
      organization: '',
      furigana_family: '',
      furigana_given: '',
      furigana_org: '',
      orgType: 'corporation'
    };
    this.userProfile = {};
    this.errorState = {
      nameErrorStyle: false,
      orgtypeErrorStyle: true,
      orgnameErrorStyle: false,
      agreementErrorStyle: false,
    };
    return;
  };
  signUp = () => {
    const { family_name, given_name, organization, furigana_family, furigana_given, furigana_org, orgType } = this.inputs;
    const orgStr = orgType === 'individual' ? '' : organization;
    const orgFuriganaStr = orgType === 'individual' ? '' : furigana_org
    const furiganaFamily = window.LAPLACEID_LOCALE === 'ja' ? furigana_family: '';
    const furiganaGiven = window.LAPLACEID_LOCALE === 'ja' ? furigana_given: '';

    const param = {
      family_name, given_name,
      'custom:organization':orgStr,
      'custom:furigana_family':furiganaFamily,
      'custom:furigana_given':furiganaGiven,
      'custom:is_agree':'1',
      'custom:account_state':'finish',
      'custom:furigana_org': orgFuriganaStr
    }

    const datum = {
      authData: this.props.authData,
      param: param,
      setter: this.loadUserProfiles,
    };

    // ローカルストレージの更新
    localStorage.setItem('USER_PROFILE', JSON.stringify(param));

    // 値のリセット
    this.setDefault();
    this.setState({
      buttonTheme: buttonNgTheme,
    });
    this.changeState('confirmation', datum);
  }
  turnErrorState = (val) => {
    this.errorState = {
      nameErrorStyle: val,
      orgtypeErrorStyle: val,
      orgnameErrorStyle: val,
      agreementErrorStyle: val,
    };
  }
  checkError = (lang) => {
    const {family_name, given_name, organization, furigana_org, is_agree} = this.inputs;
    this.turnErrorState(true);
    // 利用規約のエラーチェック
    if (!this.inputs.hasOwnProperty('is_agree') || !is_agree) {
      this.errorState.agreementErrorStyle = false;
    }
    // 名前入力のエラーチェック
    if (!this.inputs.hasOwnProperty('family_name') || !this.inputs.hasOwnProperty('given_name')) {
      this.errorState.nameErrorStyle = false;
    }
    if (family_name === '' || given_name === '') {
      this.errorState.nameErrorStyle = false;
    }
    // 法人入力のエラーチェック
    if (this.inputs.hasOwnProperty('orgType')) {
      this.checkErrorOrg(organization, furigana_org, lang);
    } else {
      this.errorState.orgtypeErrorStyle = false;
      this.errorState.orgnameErrorStyle = false;
    }
    // 日本語のときはフリガナチェック
    if ('ja' === lang) {
      const {furigana_family, furigana_given} = this.inputs;
      if (!this.inputs.hasOwnProperty('furigana_family') || !this.inputs.hasOwnProperty('furigana_given')) {
        this.errorState.nameErrorStyle = false;
      }
      if (furigana_family === '' || furigana_given === '') {
        this.errorState.nameErrorStyle = false;
      }
    }
  }
  checkErrorOrg = (organization, furigana_org, lang) => {
    if (this.inputs.orgType === 'corporation') {
      if (!this.inputs.hasOwnProperty('organization')) {
        this.errorState.orgnameErrorStyle = false;
      }
      if (organization === '') {
        this.errorState.orgnameErrorStyle = false;
      }
      // 日本語のときはフリガナチェック
      if ('ja' === lang) {
        if (!this.inputs.hasOwnProperty('furigana_org')) {
          this.errorState.orgnameErrorStyle = false;
        }
        if (furigana_org === '') {
          this.errorState.orgnameErrorStyle = false;
        }
      }
    }
  }
  handleInputChange(evt) {
    this.inputs = this.inputs || {};
    const { name, value, type, checked } = evt.target;
    const check_type = ['radio', 'checkbox'].includes(type);
    this.inputs[name] = check_type? checked : value;
    this.inputs['checkedValue'] = check_type? value: null;
    
    // orgTypeはtrue/falseでなくvalueを入れるようにする
    if (name === 'orgType' && type === 'radio') {
      this.inputs[name] = value;
    }

    // エラーの取得
    this.checkError(window.LAPLACEID_LOCALE);

    // 状態を更新
    const buttonColor = this.updateButtonStatus() ? buttonNgTheme : buttonOkTheme;
    this.setState({
      buttonTheme: buttonColor,
    });
  }
  
  // parsedData で this.inputs を上書きする
  loadUserProfiles = (parsedData) => {
    if (parsedData) {
      this.userProfile = parsedData;
      // orgTypeはorganizationの文字列が空かそうでないかで決める
      let tmpOrgType = this.userProfile['custom:organization']==='' ? 'individual' : 'corporation';
      let furiganaFamily = this.userProfile['custom:furigana_family'];
      let furiganaGiven = this.userProfile['custom:furigana_given'];
      let furiganaOrg = this.userProfile['custom:furigana_org'];

      this.inputs = {
        family_name: this.userProfile.family_name,
        given_name: this.userProfile.given_name,
        organization: this.userProfile['custom:organization'],
        furigana_family: furiganaFamily,
        furigana_given: furiganaGiven,
        furigana_org: furiganaOrg,
        orgType: tmpOrgType
      }
      // エラーの取得
      this.checkError(window.LAPLACEID_LOCALE);
    }
    return;
  }
  updateButtonStatus = () => {
    let ret = false;
    for(let i of Object.keys(this.errorState)) {
      if (!this.errorState[i]) {
        ret = true;
        break;
      }
    }
    return ret;
  }
  checkLocaleWithName = (theme) => {
    if (window.LAPLACEID_LOCALE === 'ja') {
      return(
      <div className='loginInputFlex'>
        <div>
          <label className='loginLabel'>{I18n.get('Last name furigana')}</label>
          <InputRow
            placeholder={I18n.get('Last name furigana')}
            theme={theme}
            key='custom:furigana_family'
            name='furigana_family'
            onChange={this.handleInputChange}
            defaultValue={this.inputs.furigana_family}
          />
        </div>
        <div>
          <label className='loginLabel'>{I18n.get('First name furigana')}</label>
          <InputRow
            placeholder={I18n.get('First name furigana')}
            theme={theme}
            key='custom:furigana_given'
            name='furigana_given'
            onChange={this.handleInputChange}
            defaultValue={this.inputs.furigana_given}
          />
        </div>
      </div>
      );
    } else {
      return;
    }
  }
  checkLocaleWithOrg = (theme) => {
    if (window.LAPLACEID_LOCALE === 'ja') {
      return(
      <div>
        <label className='loginLabel'>{I18n.get('organization furigana')}</label>
        <InputRow
          placeholder={I18n.get('organization furigana')}
          theme={theme}
          name='furigana_org'
          onChange={this.handleInputChange}
          defaultValue={this.inputs.furigana_org}
        />
      </div>
      );
    } else {
      return;
    }
  }

  showComponent(theme) {
    const isDisable = this.updateButtonStatus() ? 'disabled' : '';
    // inputs が空のオブジェクトの時は初期化する
    if (!Object.keys(this.inputs).length) {
      // localstorage にデータがあればそちらで上書きする
      const storageParsed = JSON.parse(localStorage.getItem('USER_PROFILE'));
      if (storageParsed) {
        this.loadUserProfiles(storageParsed);
      } else {
        // なければデフォルトにする
        this.setDefault();
      }
    }

    return (
      <div className='loginContainer'>
        <LogoArea theme={theme} />
        <FormSection theme={theme}>
          <SectionHeader theme={theme}>{I18n.get('Enter your personal data')}</SectionHeader>
          <Stepper nowStatus='75%' />
          <SectionBody theme={theme}>
            <p className='loginRequiredItem'>{I18n.get('All displayed items are required.')}</p>
            <div className='loginInputFlex'>
              <div>
                <label className='loginLabel'>{I18n.get('Last name')}</label>
                <InputRow
                  placeholder={I18n.get('Last name')}
                  theme={theme}
                  key='family_name'
                  name='family_name'
                  onChange={this.handleInputChange}
                  defaultValue={this.inputs.family_name}
                />
              </div>
              <div>
                <label className='loginLabel'>{I18n.get('First name')}</label>
                <InputRow
                  placeholder={I18n.get('First name')}
                  theme={theme}
                  key='given_name'
                  name='given_name'
                  onChange={this.handleInputChange}
                  defaultValue={this.inputs.given_name}
                />
              </div>
            </div>
            {this.checkLocaleWithName(theme)}
            <div className='loginRadiobutton colNatural01'>
              <label className='loginRadiobuttonText'><Radio theme={theme} name='orgType' value='corporation' onChange={this.handleInputChange} checked={this.inputs.orgType === 'corporation'} />{I18n.get('Business')}</label>
              <label className='loginRadiobuttonText'><Radio theme={theme} name='orgType' value='individual'  onChange={this.handleInputChange} checked={this.inputs.orgType === 'individual'} />{I18n.get('Private')}</label>
            </div>
            <div style={{ display: this.inputs.orgType === 'individual' ? 'none' : '' }}>
              <label className='loginLabel'>{I18n.get('Company/Institution name')}</label>
              <InputRow
                placeholder={I18n.get('Company/Institution name')}
                theme={theme}
                name='organization'
                onChange={this.handleInputChange}
                defaultValue={this.inputs.organization}
              />
              {this.checkLocaleWithOrg(theme)}
            </div>
            <div className='loginCheckbox'>
            <label className='loginCheckboxText'>
              <Checkbox
                theme={theme}
                key='custom:is_agree'
                name='is_agree'
                onChange={this.handleInputChange}
              />
            </label>
            </div>
            <span className='tosMarginRight'>
              <Link target='_blank' rel='noreferrer noopener' href={I18n.get('https://www.lapsys.co.jp/english/policy/laplace_id.html')}>{I18n.get('Terms of service')}</Link>
            </span>
            <span className='colNatural01'>{I18n.get('I read the Terms of service and agree to its contents.')}</span>
            <div className='loginPassConditions'>
              <p className='colNatural01'>{I18n.get('Required items')}</p>
              <ul>
                <li className={!this.errorState.nameErrorStyle ? 'notValidCheckImg': 'validCheckImg'}>{I18n.get('Your name')}</li>
                <li className={!this.errorState.orgtypeErrorStyle ? 'notValidCheckImg': 'validCheckImg'}>{I18n.get('Select Business or Private')}</li>
                <li className={!this.errorState.orgnameErrorStyle ? 'notValidCheckImg': 'validCheckImg'}>{I18n.get('If you select Business, enter your Company/Institution name')}</li>
                <li className={!this.errorState.agreementErrorStyle ? 'notValidCheckImg': 'validCheckImg'}>{I18n.get('Agree to Terms of Service')}</li>
              </ul>
            </div>
            <ButtonRow style={theme.loginLargeButton} onClick={this.signUp} theme={this.state.buttonTheme} disabled={isDisable}>
              {I18n.get('Confirm')}
            </ButtonRow>
          </SectionBody>
          <SectionFooter theme={theme}>
          </SectionFooter>
        </FormSection>
      </div>
    )
  }
}
